import { createContext } from 'react';
import KickImage from 'Reuseables/KickImage';

type TGetDescriptionContextValue = (slug: string) => string;

export const GetDescriptionContext = createContext<TGetDescriptionContextValue>(
  (slug: string) => '',
);
